import React from 'react'

function Banner() {
  return (
    <div>
       <div className="container-fluid m-0 p-0">
            <div className="row m-0">
                <div className="mainframe-video">
                    <div className="video-frame"></div>
                    <div className="col-lg-8 col-12 px-4">
                        <div className="head-tag pb-3" style={{lineHeight:'45px'}}>E-commerce & Marketplace Solutions</div>
                        <p className="head-para  mb-0 px-md-5 px-sm-4 px-2 py-0">
                        Powering Seamless Online Shopping Experiences for Global Growth and Success.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Banner
